<template>
    <vue-json-pretty v-if="isJson" :deep="expand?Infinity:0" :showLine="false" showLength
                     :data="jsonData"></vue-json-pretty>
    <pre style="font-size: 14px;color:black;padding-top: 10px;font-family: monospace;white-space: pre-wrap;word-wrap: break-word;" v-else>{{text}}</pre>
</template>

<script>
    import VueJsonPretty from 'vue-json-pretty';
    import 'vue-json-pretty/lib/styles.css';

    export default {
        props: {
            text: {
                type: String
            },
            expand: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                jsonData: null,
                isJson: true
            }
        },
        watch: {
            text(val) {
                if (!val) {
                    this.isJson = false;
                    this.jsonData = null;
                    return;
                }
                try {
                    this.jsonData = JSON.parse(val);
                } catch (e) {
                    this.isJson = false;
                }
            }
        },
        created() {
            if (this.text) {
                try {
                    this.jsonData = JSON.parse(this.text);
                } catch (e) {
                    this.isJson = false;
                }
            } else {
                this.isJson = false;
            }
        },
        methods: {
            checkType(str) {
                if (!str) {
                    this.isJson = true;
                    return;
                }
                let s = str.substring(0, 1);
                if (s == '{' || s == '[') {
                    this.isJson = true;
                } else {
                    this.isJson = false;
                }
            }
        },
        components: {
            VueJsonPretty,
        },
        name: "JSONViewer"
    }
</script>
